import { render, staticRenderFns } from "./WxSelectOutGoods.vue?vue&type=template&id=3e87662d&scoped=true&"
import script from "./WxSelectOutGoods.vue?vue&type=script&lang=js&"
export * from "./WxSelectOutGoods.vue?vue&type=script&lang=js&"
import style0 from "./WxSelectOutGoods.vue?vue&type=style&index=0&id=3e87662d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e87662d",
  null
  
)

export default component.exports